export default __webpack_public_path__ + "static/media/pin-location-map.1da50680.svg";